export const stickyColumns = ['orderNumber'];
